module.exports = __webpack_public_path__ + "static/media/earlyActionYellowIcon.27612212.svg";